var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgWs = function SvgWs(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#D80027",
    d: "M24 12c0 6.627-5.373 12-12 12S0 18.627 0 12L12 0c6.627 0 12 5.373 12 12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0052B4",
    d: "M12 12V0C5.373 0 0 5.373 0 12h12Z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F0F0F0",
    d: "m9.611 7.826.194.598h.629l-.509.37.195.597-.509-.37-.509.37.195-.598-.509-.369h.629l.194-.598ZM6.454 3.131l.324.997h1.048l-.848.615.324.997-.848-.616-.847.616.324-.997-.848-.615h1.048l.323-.997ZM9.585 4.175l.324.997h1.048l-.848.615.324.997-.848-.616-.847.616.324-.997-.848-.615h1.048l.323-.997ZM7.11 8.349l.325.997h1.047l-.847.615.323.997-.847-.616-.848.616.324-.997-.848-.615h1.048l.324-.997ZM4.368 5.74l.323.996H5.74l-.848.616.324.997-.847-.616-.848.616.324-.997-.848-.616h1.048l.324-.996Z"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h24v24H0z"
  })))));
};
export default SvgWs;